<template>
  <div>
    <p>{{ $t('giftgiver.remove.info') }}</p>
    <p class="required-block mt-3 mb-2">
      {{ $t('giftgiver.remove.explanation') }}
    </p>
    <v-textarea
      v-if="has(removeGiftgiverData, 'explanation')"
      v-model="removeGiftgiverData.explanation"
      v-validate="validationRules.get('required_regular_field')"
      auto-grow
      class="mt-0 pt-0"
      :placeholder="$t('message.contact_preferences')"
      :error-messages="errors.collect('required_regular_field')"
      :data-vv-as="' '"
      data-vv-name="required_regular_field"
    />
    <v-checkbox
      v-if="has(removeGiftgiverData, 'notification')"
      v-model="removeGiftgiverData.notification"
      required
      :false-value="CHECKBOX_FALSE_VALUE"
      :true-value="CHECKBOX_TRUE_VALUE"
      type="checkbox"
    >
      <template slot="label">
        <p class="mb-0">
          {{ $t('giftgiver.remove.notification') }}
        </p>
      </template>
    </v-checkbox>
  </div>
</template>

<script>
import validationRules from '@/constants/validationRules';
import { mapFields } from 'vuex-map-fields';
import has from 'lodash.has';
import { CHECKBOX_TRUE_VALUE, CHECKBOX_FALSE_VALUE } from '@/constants/forms';

export default {
    name: 'RemoveGiftgiverForm',
    inject: ['$validator'],
    data () {
        return {
            has,
            validationRules,
            CHECKBOX_TRUE_VALUE,
            CHECKBOX_FALSE_VALUE
        };
    },
    computed: {
        ...mapFields('giftgiver', ['removeGiftgiverData'])
    }
};
</script>

<style scoped></style>
